// okendo-pdp-note.js  –– adds First-Edition notice on the Chromatics PDP
(function () {
  const NOTE_TEXT =
    'Reviews from June 2025 and earlier are for First-Edition Chromatics.';

  /** Inject the note only *after* the rating header exists */
  function insertEditionNote() {
    document.querySelectorAll('[data-oke-widget]').forEach((widget) => {
      // Find the first header-ish element inside the widget
      const header = widget.querySelector(
        '.oke-w-ratingAverageModule, .oke-w-header, .oke-w-header-content'
      );
      if (!header) return;                    // header not in DOM yet → try later
      if (widget.querySelector('.okendo-edition-note')) return; // already added

      const note = document.createElement('p');
      note.className = 'okendo-edition-note';
      note.textContent = NOTE_TEXT;

      header.after(note);                     // puts it *right below* the rating
    });
  }

  /** Styling */
  function addStyles() {
    if (document.getElementById('okendo-pdp-note-style')) return;
    const s = document.createElement('style');
    s.id = 'okendo-pdp-note-style';
    s.textContent = `
      .okendo-edition-note {
        font-size: 1.05rem;
        color: #6b6b6b;
        margin-top: 1.25rem !important;   /* ⬆️ more space above */
        margin-bottom: 0.5rem !important;
        line-height: 1.1 !important;      /* ⬇️ tighter lines */
        font-style: italic;
      }
    `;
    document.head.appendChild(s);
  }

  function init() {
    addStyles();
    insertEditionNote(); // first run
    // Keep trying as the widget renders/refreshes
    new MutationObserver(insertEditionNote).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
